import { api } from "../../services/Api.js";
//import { appVersion } from '../../services/AppVersion.js'; // generated from npm script if build from _BUILD_TOOLS/NMP_RUN_CORDOVA.sh
////import { pushNotifications } from "../../services/PushNotifications.js";
//import { cordovaInit } from '../../services/CordovaInit.js';
import { SETTINGS } from '../../SETTINGS.js'


import pushManager from '../../services/PushManager.js'

export async function register_device({ state, dispatch } ){


  

  
  // load serviceworker
  await pushManager._registerServiceWorker();

 
  const subscription = await pushManager.subscribeUser();

  // subscribing the user
  /*
  const subscription = await pushManager.subscribeUser().then(
    (subscription)=>{
      //console.log("subscription->",subscription)
      // add subscription data to login data
      
      return subscription
      //console.log("subscribed now move on")
    }
  ).catch((error)=>{
    // error push subscription, just go further with the flow.

    console.log("cant subscribe for pushnotes"+error)
  });
  */

  //console.log(subscription)
    
    /* mobile cordova version
    var payload={
            appVersion: appVersion.getBuild() ? appVersion.getBuild() : undefined,
            devicePlatform: window.device ? window.device.platform : undefined,
            deviceModel: window.device ? window.device.model : undefined,
            deviceUUID: window.device ? window.device.uuid : undefined,
            deviceVersion: window.device ? window.device.version : undefined,
            token:state.appSettings.token,
            regID:pushNotifications.regID,
    }
    */

    // get some sort of unioque device id.., its really current logged in uder with the scool name
  let uuid = await dispatch('get_device_id');

    
    var payload={
            appVersion: SETTINGS.version,
            devicePlatform: "web",
            deviceModel: window.navigator.userAgent,
            deviceUUID: uuid,
            deviceVersion: window.navigator.userAgent,
            token:state.appSettings.token,
            regID:JSON.stringify(subscription)
    }
    
   
    var school={
      protocol:'https://',
      url:"schoolsunited.eu",
    }
    
    //console.dir(payload)



    api
      .post(school,"registration.php",payload)
      .then( (result) =>{
       
        // device is registered
        console.log("**** registration.php result ",result);
      })
      .catch( (e) => {
        // error registering device in api
        alert("error registering device"+e)
      })
    
  }